const mobileFilterList = () => {
    var filterTrigger = document.querySelector('.mobile-filter-trigger');
    var filterClose = document.querySelector('.mobile-filter-close');
    var filterList = document.querySelector('.filters-list-wrapper');

    filterTrigger.addEventListener('click', () =>{
        filterList.classList.add('visible');
        document.body.classList.add('overflow-hidden');
    })

    filterClose.addEventListener('click', () =>{
        filterList.classList.remove('visible');
        document.body.classList.remove('overflow-hidden');
    })

}
export default mobileFilterList;